var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dropper",class:{dragging:_vm.dragging},on:{"click":_vm.click,"dragover":_vm.dragover,"dragleave":_vm.dragleave,"drop":_vm.drop}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }